module.exports = __webpack_public_path__ + "static/media/record-active.d40a0958.svg";